// reusable selectors for auth Slices
import { useSelector } from "react-redux";
import { IBankDetails } from "redux/reducers/bankDetailsSlice";
import { RootSliceType } from "redux/reducers/rootReducer";

const useBankDetailsSelector = () => {
  const bankDetails = useSelector<RootSliceType, IBankDetails["bankDetails"]>(
    (state) => state.bankDetails
  );
  return {
    bankDetails,
  };
};

export { useBankDetailsSelector };
